import { render, staticRenderFns } from "./changePasswordPage.vue?vue&type=template&id=54715a12&scoped=true&"
import script from "./changePasswordPage.vue?vue&type=script&lang=js&"
export * from "./changePasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./changePasswordPage.vue?vue&type=style&index=0&id=54715a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54715a12",
  null
  
)

export default component.exports